import { CalculationSection } from '@features/glossary/domain/calculations';
import { SHARED_CALCULATIONS } from '@features/glossary/domain/shared-calculations';

export const CALCULATIONS: Readonly<Record<'salesLift', CalculationSection>> = {
  salesLift: {
    label: 'Sales Lift',
    items: {
      incrementalSales: {
        label: 'Incremental Sales',
        calculationType: 'simple',
        calculation:
          'Incremental Sales = (Exposed Sales - Control Sales) * Projection Factor',
      },
      incrementalSalesLift: {
        label: 'Incremental Sales Lift',
        calculationType: 'simple',
        calculation: '(Exposed Sales - Control Sales) / Control Sales',
      },
      incrementalReturnOnAdSpend:
        SHARED_CALCULATIONS.incrementalReturnOnAdSpend,
      totalProjectedSales: {
        label: 'Total Projected Sales',
        calculationType: 'simple',
        calculation: 'Total Sales = Exposed Sales * Projection Factor',
      },
      returnOnAdSpend: SHARED_CALCULATIONS.returnOnAdSpend,
      salesRate: {
        label: 'Sales Rate',
        calculationType: 'simple',
        calculation:
          'Sales Rate = Total Projected Sales / Unique Users (exposed)',
      },
    },
  },
};
